module.exports = __webpack_public_path__ + "img/login_img_zhuchechenggong@3x.c120d9ef.png";